<template>
  <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Variable</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Variable</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a href="javascript:void(0)" class="btn add-btn" :class="{ disabled: isLimitReached }"
                  @click="openCreate">
                  <i class="fa fa-plus"></i> Tambah Variable
                </a>
                <!-- Trigger modal mengikuti pola /crm/group/list (data-toggle Bootstrap) -->
                <a ref="btnAddModal" v-show="false" href="#" data-toggle="modal"
                  data-target="#variable_form"></a>
                <a ref="btnEditModal" v-show="false" href="#" data-toggle="modal"
                  data-target="#variable_form"></a>
              </div>
            </div>
          </div>

          <!-- Quota -->
          <div class="alert alert-info" v-if="maxVariables > 0 && !serverParams.search">
            Terpakai <b>{{ totalRecords }}</b> dari maksimal <b>{{ maxVariables }}</b> variable.
            <span class="text-danger" v-if="isLimitReached">
              Batas maksimal tercapai. Hapus variable lain untuk menambah.
            </span>
          </div>

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-4">
              <div class="form-group">
                <input v-model="serverParams.search" type="text" class="form-control"
                  placeholder="Cari nama variable..." @keyup.enter="searchData" />
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click="searchData" class="btn btn-success btn-block">Search</a>
            </div>
            <div class="col-sm-12 col-md-3">
              <button type="button" class="btn btn-danger btn-block"
                :disabled="selectedIds.length === 0 || bulkDeleting" @click="confirmBulkDelete">
                <span v-if="bulkDeleting">
                  <i class="fa fa-spinner fa-spin"></i> Menghapus...
                </span>
                <span v-else>
                  <i class="fa fa-trash"></i> Hapus Terpilih ({{ selectedIds.length }})
                </span>
              </button>
            </div>
          </div>

          <!-- Table -->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 40px;">
                        <input type="checkbox" :checked="isAllSelected"
                          :indeterminate.prop="isIndeterminate"
                          :disabled="bulkDeleting || loading || rows.length === 0"
                          aria-label="Pilih semua variable di halaman ini"
                          @change="toggleSelectAll" />
                      </th>
                      <th>#</th>
                      <th class="text-wrap">Nama Variable</th>
                      <th class="text-wrap">Nilai</th>
                      <th class="text-wrap">Deskripsi</th>
                      <th class="text-center">Terakhir Diubah</th>
                      <th class="text-right">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="7">
                          <Skeleton :count="3" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="row.id">
                        <td class="text-center">
                          <input type="checkbox" v-model="selectedIds" :value="row.id"
                            :disabled="bulkDeleting"
                            :aria-label="'Pilih variable ' + row.variable_name" />
                        </td>
                        <td>{{ (currentPage - 1) * parseInt(serverParams.per_page) + index + 1 }}</td>
                        <td class="text-wrap"><code>{{ row.variable_name }}</code></td>
                        <td class="text-wrap">{{ row.variable_value }}</td>
                        <td class="text-wrap">{{ row.description }}</td>
                        <td class="text-center">{{ formatDateTime(row.update_datetime) }}</td>
                        <td class="text-right">
                          <a href="javascript:void(0)" class="btn btn-sm btn-primary" title="Edit"
                            @click="openEdit(row)">
                            <i class="fa fa-pencil"></i>
                          </a>
                          <a href="javascript:void(0)" class="btn btn-sm btn-danger" title="Hapus"
                            @click="confirmDelete(row)">
                            <i class="fa fa-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="7" class="text-center">- Data Kosong -</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="row mt-3" v-if="totalRecords > 0">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange" v-model="serverParams.per_page"
                class="select-to-paginasi mx-2" style="width: 100px;">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="50">50 / page</option>
                <option value="100">100 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <button class="btn btn-sm" :class="{ disabled: currentPage <= 1 }"
                @click="changePage(currentPage - 1)">
                <span class="chevron left"></span> Prev
              </button>
              <span class="mx-2">
                Page
                <input style="width:50px; text-align:center" min="1" type="number"
                  v-model.number="currentPageInput" @keyup.enter="changePage(currentPageInput)" />
                of {{ maxPage }}
              </span>
              <button class="btn btn-sm" :class="{ disabled: currentPage >= maxPage }"
                @click="changePage(currentPage + 1)">
                Next <span class="chevron right"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Modal -->
      <div id="variable_form" class="modal custom-modal fade" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ isEdit ? "Edit Variable" : "Tambah Variable" }}</h5>
              <button ref="dismisModal" type="button" class="close" data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="save">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Nama Variable <span class="text-danger">*</span></label>
                      <input v-model="form.variable_name" type="text" class="form-control"
                        :class="{ 'is-invalid': errors.variable_name }" placeholder="contoh: product_1"
                        maxlength="100" />
                      <small class="text-muted">
                        Diawali huruf; hanya huruf, angka, dan garis bawah. Tanpa tanda dollar,
                        spasi, atau kurung kurawal.
                      </small>
                      <div class="text-danger" v-if="errors.variable_name">{{ errors.variable_name }}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Nilai Variable <span class="text-danger">*</span></label>
                      <textarea v-model="form.variable_value" class="form-control" rows="3"
                        :class="{ 'is-invalid': errors.variable_value }"
                        placeholder="contoh: Rp 50.000" maxlength="10000"></textarea>
                      <div class="text-danger" v-if="errors.variable_value">{{ errors.variable_value }}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Deskripsi <span class="text-muted">(opsional)</span></label>
                      <textarea v-model="form.description" class="form-control" rows="2"
                        :class="{ 'is-invalid': errors.description }"
                        placeholder="contoh: Nama produk utama" maxlength="255"></textarea>
                      <div class="text-danger" v-if="errors.description">{{ errors.description }}</div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                  <button type="submit" class="btn btn-primary" :disabled="saving">
                    <span v-if="saving"><i class="fa fa-spinner fa-spin"></i> Menyimpan...</span>
                    <span v-else>Simpan</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import { Skeleton } from "vue-loading-skeleton";
import { formatLocalDate } from "@/utils/helper";

export default {
  name: "variable",
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
    Skeleton
  },
  data() {
    return {
      rows: [],
      totalRecords: 0,
      totalAllRecords: 0,
      loading: false,
      saving: false,
      bulkDeleting: false,
      selectedIds: [],
      currentPage: 1,
      currentPageInput: 1,
      serverParams: {
        page: 1,
        per_page: 20,
        search: ""
      },
      isEdit: false,
      errors: {},
      form: {
        id: "",
        variable_name: "",
        variable_value: "",
        description: ""
      }
    };
  },
  computed: {
    maxVariables() {
      return this.$store.state.variable.maxVariables;
    },
    maxPage() {
      return Math.ceil(this.totalRecords / parseInt(this.serverParams.per_page)) || 1;
    },
    isLimitReached() {
      return this.maxVariables > 0 && this.totalAllRecords >= this.maxVariables;
    },
    isAllSelected() {
      return (
        this.rows.length > 0 &&
        this.rows.every((row) => this.selectedIds.indexOf(row.id) !== -1)
      );
    },
    isIndeterminate() {
      const selectedOnPage = this.rows.filter(
        (row) => this.selectedIds.indexOf(row.id) !== -1
      ).length;

      return selectedOnPage > 0 && selectedOnPage < this.rows.length;
    }
  },
  created() {
    this.loadItems();
  },
  methods: {
    formatDateTime(value) {
      if (!value) return "-";
      return formatLocalDate(value);
    },

    async loadItems() {
      // Pilihan tidak boleh terbawa ke halaman/filter lain.
      this.selectedIds = [];
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          per_page: parseInt(this.serverParams.per_page),
          search: this.serverParams.search || ""
        };

        const response = await this.$store.dispatch("variable/getVariableList", params);
        const { data } = response;

        this.rows = data.data || [];
        this.totalRecords = data.totalRecords || 0;
        if (!params.search) {
          this.totalAllRecords = data.totalRecords || 0;
        }
        this.currentPageInput = this.currentPage;
      } catch (error) {
        this.rows = [];
        this.totalRecords = 0;
      } finally {
        this.loading = false;
      }
    },

    searchData() {
      this.currentPage = 1;
      this.loadItems();
    },

    changePage(page) {
      const targetPage = parseInt(page);
      if (targetPage >= 1 && targetPage <= this.maxPage) {
        this.currentPage = targetPage;
        this.loadItems();
      } else {
        this.currentPageInput = this.currentPage;
      }
    },

    onPerPageChange() {
      this.currentPage = 1;
      this.loadItems();
    },

    toggleSelectAll(event) {
      const checked = event.target.checked;
      const pageIds = this.rows.map((row) => row.id);

      if (checked) {
        this.selectedIds = Array.from(
          new Set(this.selectedIds.concat(pageIds))
        );
      } else {
        this.selectedIds = this.selectedIds.filter(
          (id) => pageIds.indexOf(id) === -1
        );
      }
    },

    async reloadAfterDelete() {
      await this.loadItems();

      // Jika halaman aktif menjadi tidak valid, kembali ke halaman terakhir.
      if (this.currentPage > this.maxPage) {
        this.currentPage = this.maxPage;
        await this.loadItems();
      }
    },

    async confirmBulkDelete() {
      if (this.bulkDeleting || this.selectedIds.length === 0) {
        return;
      }

      const ids = Array.from(
        new Set(
          this.selectedIds
            .map((id) => parseInt(id))
            .filter((id) => !isNaN(id) && id > 0)
        )
      );

      if (ids.length === 0) {
        return;
      }

      const confirmResult = await this.$fire({
        title: "Hapus " + ids.length + " variable terpilih?",
        text: "Variable yang dipilih akan dihapus dan tidak dapat dikembalikan.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Hapus",
        cancelButtonText: "Batal"
      });

      if (!confirmResult.value) {
        return;
      }

      this.bulkDeleting = true;

      const succeededIds = [];
      const failedIds = [];

      try {
        // Backend hanya menyediakan delete per ID.
        for (let i = 0; i < ids.length; i++) {
          try {
            await this.$store.dispatch("variable/deleteVariable", {
              id: ids[i]
            });
            succeededIds.push(ids[i]);
          } catch (error) {
            failedIds.push(ids[i]);
          }
        }

        await this.reloadAfterDelete();

        // Pertahankan pilihan hanya untuk ID gagal yang masih tampil.
        this.selectedIds = failedIds.filter((id) => {
          return this.rows.some((row) => parseInt(row.id) === id);
        });

        if (failedIds.length === 0) {
          this.$fire({
            title: "Berhasil",
            text: succeededIds.length + " variable berhasil dihapus.",
            type: "success",
            timer: 2000
          });
        } else if (succeededIds.length === 0) {
          this.$fire({
            title: "Gagal",
            text: failedIds.length + " variable gagal dihapus. Silakan coba lagi.",
            type: "error"
          });
        } else {
          this.$fire({
            title: "Sebagian Berhasil",
            text:
              succeededIds.length +
              " variable berhasil dihapus, " +
              failedIds.length +
              " gagal dihapus.",
            type: "warning"
          });
        }
      } finally {
        this.bulkDeleting = false;
      }
    },

    resetForm() {
      this.errors = {};
      this.form = {
        id: "",
        variable_name: "",
        variable_value: "",
        description: ""
      };
    },

    openCreate() {
      if (this.isLimitReached) {
        this.$fire({
          title: "Batas Tercapai",
          text: "Batas maksimal " + this.maxVariables + " variable sudah tercapai. Hapus variable lain terlebih dahulu.",
          type: "warning"
        });
        return;
      }

      this.isEdit = false;
      this.resetForm();
      this.$nextTick(() => {
        this.$refs.btnAddModal.click();
      });
    },

    async openEdit(row) {
      this.isEdit = true;
      this.errors = {};
      this.form = {
        id: row.id,
        variable_name: row.variable_name,
        variable_value: row.variable_value,
        description: row.description || ""
      };
      this.$nextTick(() => {
        this.$refs.btnEditModal.click();
      });

      // Ambil data terbaru dari endpoint detail; jika gagal, gunakan data list.
      try {
        const response = await this.$store.dispatch("variable/getVariableDetail", {
          id: parseInt(row.id)
        });

        if (
          response &&
          response.data &&
          this.isEdit &&
          parseInt(this.form.id) === parseInt(row.id)
        ) {
          this.form = {
            id: response.data.id,
            variable_name: response.data.variable_name,
            variable_value: response.data.variable_value,
            description: response.data.description || ""
          };
        }
      } catch (error) {
        // Gunakan data dari list sebagai fallback.
      }
    },

    validateForm() {
      this.errors = {};

      const name = this.form.variable_name;
      const value = this.form.variable_value;
      const description = this.form.description;

      if (!name) {
        this.errors.variable_name = "Nama variable wajib diisi.";
      } else if (name.length > 100) {
        this.errors.variable_name = "Nama variable maksimal 100 karakter.";
      } else if (!/^[a-zA-Z][a-zA-Z0-9_]{0,99}$/.test(name)) {
        this.errors.variable_name =
          "Nama variable harus diawali huruf dan hanya boleh berisi huruf, angka, dan garis bawah (contoh: product_1).";
      }

      if (!value || value.trim() === "") {
        this.errors.variable_value = "Nilai variable wajib diisi.";
      } else if (value.length > 10000) {
        this.errors.variable_value = "Nilai variable maksimal 10000 karakter.";
      }

      if (description && description.length > 255) {
        this.errors.description = "Deskripsi variable maksimal 255 karakter.";
      }

      return Object.keys(this.errors).length === 0;
    },

    async save() {
      if (!this.validateForm()) {
        return;
      }

      this.saving = true;

      // Update bersifat full replace: selalu kirim semua field.
      const payload = {
        variable_name: this.form.variable_name,
        variable_value: this.form.variable_value,
        description: this.form.description || ""
      };

      try {
        if (this.isEdit) {
          payload.id = parseInt(this.form.id);
          await this.$store.dispatch("variable/updateVariable", payload);
        } else {
          await this.$store.dispatch("variable/createVariable", payload);
        }

        this.$refs.dismisModal.click();
        this.$fire({
          title: "Berhasil",
          text: this.isEdit ? "Variable berhasil diperbarui." : "Variable berhasil disimpan.",
          type: "success",
          timer: 2000
        });

        await this.loadItems();
      } catch (error) {
        // Pesan error sudah ditampilkan oleh interceptor requestRaw.
      } finally {
        this.saving = false;
      }
    },

    async confirmDelete(row) {
      const confirmResult = await this.$fire({
        title: "Konfirmasi Hapus",
        text:
          'Hapus variable "' +
          row.variable_name +
          '"? Tindakan ini tidak bisa dibatalkan.',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Hapus",
        cancelButtonText: "Batal"
      });

      if (!confirmResult.value) {
        return;
      }

      this.loading = true;
      try {
        await this.$store.dispatch("variable/deleteVariable", {
          id: parseInt(row.id)
        });

        this.$fire({
          title: "Berhasil",
          text: "Variable berhasil dihapus.",
          type: "success",
          timer: 2000
        });

        // Jika data terakhir di halaman ini terhapus, mundurkan halaman.
        if (this.rows.length === 1 && this.currentPage > 1) {
          this.currentPage -= 1;
        }

        await this.loadItems();
      } catch (error) {
        // Pesan error sudah ditampilkan oleh interceptor requestRaw.
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/variable.vue